import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles((theme) => ({
  root: {
    width: 416,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.props.border,
  },
  header: {
    paddingRight: 8,
    height: 35,
    // borderBottom: `1px solid ${theme.props.border}`,
  },
  navi: {
    fontSize: "16px !important",
    letterSpacing: "normal !important",
    fontWeight: "normal !important",
    marginBottom: -1,
  },
}));

export default useStyle;
